import { Menu } from 'antd'
import { csvIconSVG } from '../assets/svg/csvIcon'
import { pdfIconSVG } from '../assets/svg/pdfIcon'
import { styled, theme } from '../theme'
import { useFormatMessage } from '../helpers/intl'
import { buildPublicFontUrl } from '../helpers/url'
import { downloadSVG } from 'assets/svg/download'

interface props {
  chart: any
  onClickCSV?(): void
}

export const ExportFilesContainer = styled.div`
  .exportData-sub-menu {
    color: ${theme.colors.menuBackground};
    background: ${theme.colors.primary};
    border: 1px solid ${theme.colors.primary};
    border-radius: 20px;
    text-transform: uppercase;
    text-shadow: none;
    width: 38px;
    height: 38px;
    display: flex;
    justify-content: center;
    padding: 0 !important;
  }

  li.exportData-sub-menu svg {
    margin-left: 10px;
    margin-top: 6px;
    transition: transform 0.4s ease-in-out;
  }

  li.exportData-sub-menu:hover {
    background: ${theme.colors.buttonHovering};
    border: 1px solid ${theme.colors.buttonHovering};
    border-radius: 20px;
    text-transform: uppercase;
    text-shadow: none;
  }
`

const appendFontFamily = () => {
  var fontStyle = document.createElement('style')

  fontStyle.appendChild(
    document.createTextNode(
      `\
@font-face {\
font-family: 'AkkuratLLWeb-Regular';\
font-style: normal;\
font-weight: 400;\
src: local('AkkuratLLWeb Regular'), local('AkkuratLLWeb-Regular'), url(${buildPublicFontUrl(
        'AkkuratLLWeb-Regular.woff2',
      )}) format('woff2');\
              \
            }\
            `,
    ),
  )

  document.head.appendChild(fontStyle)
}

export const DownloadFilesMenu: React.FC<props> = ({ chart, onClickCSV }) => {
  const exportToPdfText = useFormatMessage('dashboard.homePage.exportGraph.pdf', 'Export as PDF')
  const exportToCSVText = useFormatMessage('dashboard.homePage.exportGraph.csv', 'Export as CSV')
  return (
    <ExportFilesContainer>
      <Menu theme="light" mode="horizontal" className="download-sub-menu">
        <Menu.SubMenu key="exportData-sub-menu" icon={downloadSVG} className="exportData-sub-menu">
          <Menu.Item
            key="import-to-pdf"
            icon={pdfIconSVG}
            onClick={() => {
              //@ts-ignore
              appendFontFamily()
              chart.current.chart.exportChart({
                type: 'application/pdf',
              })
            }}
            className="download-sub-menu-item pdf"
          >
            {exportToPdfText}
          </Menu.Item>
          <Menu.Item
            key="import-to-csv"
            icon={csvIconSVG}
            onClick={() => {
              typeof onClickCSV !== 'undefined' && onClickCSV()
              //@ts-ignore
              chart.current.chart.downloadCSV()
            }}
            className="download-sub-menu-item csv"
          >
            {exportToCSVText}
          </Menu.Item>
        </Menu.SubMenu>
      </Menu>
    </ExportFilesContainer>
  )
}
